const URL = process.env.REACT_APP_API_URL;
const PROXY = process.env.REACT_APP_PROXY_URL;

export const api_url = PROXY + URL;

const username = process.env.REACT_APP_USERNAME;
const password = process.env.REACT_APP_PASSWORD;

const supabaseProjectId = process.env.REACT_APP_SUPABASE_PROJECT_ID;

export const generateAuthHeader = () => {
  if (process.env.AUTH_ENV === "development") {
    return generateBasicAuthToken();
  }
  return getSupaToken();
};

export const generateBasicAuthToken = () => {
  const credentials = username + ":" + password;
  return "basic " + btoa(credentials);
};

const getSupaToken = () => {
  const storageKey = `sb-${supabaseProjectId}-auth-token`;
  const sessionDataString = localStorage.getItem(storageKey);
  const sessionData = JSON.parse(sessionDataString || "null");
  const token = sessionData?.access_token;

  return "Bearer " + token;
};

export const API = {
  ENDPOINTS: {
    score: "score",
    search: "search",
    trending: "trending",
    news: "news",
    googleNews: "news/googlenews",
    hackerNews: "news/hackernews",
    newsApi: "news/newsapi",
    ventureBeat: "news/venturebeat",
    techCrunch: "news/techcrunch",
    keyPeople: "keypeople",
    founders: "founders",
    financial: "fundingrounds",
    competitors: "competitors",
    check: "analytics/check_aquisions",
    challenge: "analytics/challenges",
    unique: "analytics/what_makes_unique",
    aiProduct: "analytics/ai_products",
    explainProducts: "analytics/explain_product",
    chat: "chat",
  },
};
